import $ from 'jquery';

class MaRSNewsSeries {

  //describe and create/initiate object
  constructor() {
    this.resultsDiv = $(".newsSeriesBlock__results");
    this.loadMoreButton = $(".newsSeriesBlock__load a");
    this.searchField = $(".newsSeriesBlock").attr('data-term');
    this.isSpinnerVisible = false;

    this.loadInfo;
    this.events();
    setTimeout(this.getResults(), 750);


  }

  //events
  events() {
    // $(document).on("click", ".newsSeriesBlock__link", this.openDetailsOverlay.bind(this));

    this.loadMoreButton.on("click", this.getMoreResults.bind(this));

  }



  
  getResults() {
    if ($(".newsSeriesBlock__results").length) {

      if (!this.isSpinnerVisible) {
        this.resultsDiv.append(`
          <div class="col-12">
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>
          </div>`);
        this.isSpinnerVisible = true;
      }

      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/newsseries?taxonomySlug=' + this.searchField + '&page=1', (results) => {

        let currentPage = results.current_page;

        this.resultsDiv.html(`
          ${results.marsNewsSeries.length ? '' : '<p>No results matches the search term.</p>'}

          ${results.marsNewsSeries.map(item =>
            `<div class="col-12 col-md-12 newsSeriesBlock__card newsSeriesBlock__default">
              <div class="newsSeriesBlock__wrap">
                <a
                  href="${item.permalink}">
                  <div class="newsSeriesBlock__contentWrapper">
                    <div class="row no-gutters">
                      <div class="col-12 col-sm-4 newsSeriesBlock__postImage"
                        style="background: url('${item.thumbnail}') no-repeat">
                        <div class="newsSeriesBlock__mask"></div>
                        <svg class="newsSeriesBlock__arrow" xmlns="http://www.w3.org/2000/svg" width="45" height="10"
                          viewBox="0 0 45 10">
                          <g fill="none" fill-rule="evenodd" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round"
                            stroke-width="1.5">
                            <path d="M1 5h42M40 1l4 4-4 4"></path>
                          </g>
                        </svg>
                      </div>
                      <div class="col-12 col-sm-1"></div>
                      <div class="col-12 col-sm-7">
                        <span class="newsSeriesBlock__category">${results.taxonomySlug}</span>
                        <h3 class="bold">${item.title}</h3>
                        <p>${item.description}</p>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>`
          ).join('')}

      `);
        this.isSpinnerVisible = false;
        this.searchField ? this.loadMoreButton.attr("data-url", `taxonomySlug=${this.searchField}&page=2`) : '';
        `${results.max_pages == currentPage || results.max_pages == 0 ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
      }).fail(function (jqXHR, textStatus, error) {
      });
    }
  }





  getMoreResults(e) {
    e.preventDefault();
    this.loadInfo = this.loadMoreButton.attr("data-url");


    if (!this.isSpinnerVisible) {
      this.resultsDiv.append(`
          <div class="col-12">
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>
          </div>`);
      this.isSpinnerVisible = true;
    }


    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/newsseries?' + this.loadInfo, (results) => {

      let currentPage = results.current_page;

      this.resultsDiv.append(`
        ${results.marsNewsSeries.length ? '' : '<p>No more results matches the search term.</p>'}

        ${results.marsNewsSeries.map(item =>
          `<div class="col-12 col-md-12 newsSeriesBlock__card newsSeriesBlock__default">
            <div class="newsSeriesBlock__wrap">
              <a
                href="${item.permalink}">
                <div class="newsSeriesBlock__contentWrapper">
                  <div class="row no-gutters">
                    <div class="col-12 col-sm-4 newsSeriesBlock__postImage"
                      style="background: url('${item.thumbnail}') no-repeat">
                      <div class="newsSeriesBlock__mask"></div>
                      <svg class="newsSeriesBlock__arrow" xmlns="http://www.w3.org/2000/svg" width="45" height="10"
                        viewBox="0 0 45 10">
                        <g fill="none" fill-rule="evenodd" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.5">
                          <path d="M1 5h42M40 1l4 4-4 4"></path>
                        </g>
                      </svg>
                    </div>
                    <div class="col-12 col-sm-1"></div>
                    <div class="col-12 col-sm-7">
                      <span class="newsSeriesBlock__category">${results.taxonomySlug}</span>
                      <h3 class="bold">${item.title}</h3>
                      <p>${item.description}</p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>`
        ).join('')}

      `);
      $('.sk-double-bounce').parent().remove();
      this.isSpinnerVisible = false;
      if (this.searchField.length > 1) {
        this.loadMoreButton.attr("data-url", `taxonomySlug=${this.searchField}&page=${parseInt(currentPage) + 1}`);
      }
      else {
        this.loadMoreButton.attr("data-url", `program=${currentProgram[0]}&page=${parseInt(currentPage) + 1}`);
      }
      `${results.max_pages == currentPage || results.max_pages == 0 ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function (jqXHR, textStatus, error) {
    });
  }


}

export default MaRSNewsSeries;